import React from 'react';
import { useTranslation } from 'react-i18next';
import './DemoBanner.css';

/**
 * Fine bandeau démo tout en haut du shell (flux normal : au-dessus de la barre ERP).
 */
const DemoBanner = ({ packageName, onQuit }) => {
  const { t } = useTranslation();

  const handleQuitClick = () => {
    if (window.confirm(t('onlineDemo.banner.quit_confirm'))) {
      onQuit();
    }
  };

  return (
    <aside className="demo-banner" aria-label={t('onlineDemo.banner.aria_label')}>
      <div className="demo-banner__inner">
        <span className="demo-banner__badge">{t('onlineDemo.banner.demo_badge')}</span>
        <p className="demo-banner__text">
          <strong>{packageName}</strong>
          {t('onlineDemo.banner.demo_data_local')}
        </p>
        <button type="button" className="demo-banner__quit" onClick={handleQuitClick}>
          {t('onlineDemo.banner.quit')}
        </button>
      </div>
    </aside>
  );
};

export default DemoBanner;
